<template>
  <BlockFieldset class="project-plant-data">
    <b-row>
      <b-col lg="6" md="6" sm="12">
        <b-form-group
          horizontal
          :label="$t('iabInstallationType')"
          label-for="installationType"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <b-form-input
            id="installationType"
            v-model="project.investmentDeductionAllowance.installationType"
            :disabled="isBlockReadOnly"
            type="text"
            :placeholder="$t('iabInstallationType')"
          />
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('investmentDeductionAllowance_areaInSquareMeters')"
          label-for="areaInSquareMeters"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <UnitInputNumber
            id="areaInSquareMeters"
            v-model="project.investmentDeductionAllowance.areaInSquareMeters"
            :disabled="isBlockReadOnly"
            unit="unit_square_meter"
            :minFractionDigits="0"
            :maxFractionDigits="2"
          />
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('specificAnnualYieldKwhPerKwp')"
          label-for="specificAnnualYieldKwhPerKwp"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <UnitInputNumber
            id="specificAnnualYieldKwhPerKwp"
            v-model="project.investmentDeductionAllowance.specificAnnualYieldKwhPerKwp"
            :disabled="isBlockReadOnly"
            unit="unit_kwh_per_kwp"
          />
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('initialFeedInTariffDurationYears')"
          label-for="initialFeedInTariffDurationYears"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <UnitInputNumber
            id="initialFeedInTariffDurationYears"
            v-model="project.investmentDeductionAllowance.initialFeedInTariffDurationYears"
            :disabled="isBlockReadOnly"
            unit="unit_years"
          />
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('calculatedEEGfeedInTariffEurPerKwh')"
          label-for="calculatedEEGfeedInTariffEurPerKwh"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <div class="form-control-plaintext">
            {{ calculatedEEGfeedInTariffEurPerKwhFormatted }}
          </div>
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('feedInTariffGuaranteeCaseEurPerKwh')"
          label-for="feedInTariffGuaranteeCaseEurPerKwh"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <UnitInputNumber
            id="feedInTariffGuaranteeCaseEurPerKwh"
            v-model="project.investmentDeductionAllowance.feedInTariffGuaranteeCaseEurPerKwh"
            :disabled="isBlockReadOnly"
            unit="unit_eur_per_kwh"
            :minFractionDigits="5"
            :maxFractionDigits="5"
          />
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('feedInTariffMedianCaseEurPerKwh')"
          label-for="feedInTariffMedianCaseEurPerKwh"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <UnitInputNumber
            id="feedInTariffMedianCaseEurPerKwh"
            v-model="project.investmentDeductionAllowance.feedInTariffMedianCaseEurPerKwh"
            :disabled="isBlockReadOnly"
            unit="unit_eur_per_kwh"
            :minFractionDigits="5"
            :maxFractionDigits="5"
          />
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('feedInTariffOptimalCaseEurPerKwh')"
          label-for="feedInTariffOptimalCaseEurPerKwh"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <UnitInputNumber
            id="feedInTariffOptimalCaseEurPerKwh"
            v-model="project.investmentDeductionAllowance.feedInTariffOptimalCaseEurPerKwh"
            :disabled="isBlockReadOnly"
            unit="unit_eur_per_kwh"
            :minFractionDigits="5"
            :maxFractionDigits="5"
          />
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('expectedFeedInTariffIncreasePercentPerYear')"
          label-for="expectedFeedInTariffIncreasePercentPerYear"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <UnitInputNumber
            id="expectedFeedInTariffIncreasePercentPerYear"
            v-model="
              project.investmentDeductionAllowance.expectedFeedInTariffIncreasePercentPerYear
            "
            :disabled="isBlockReadOnly"
            unit="unit_percent"
          />
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('degradationPercentPerYear')"
          label-for="degradationPercentPerYear"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <UnitInputNumber
            id="degradationPercentPerYear"
            v-model="project.investmentDeductionAllowance.degradationPercentPerYear"
            :disabled="isBlockReadOnly"
            unit="unit_percent"
          />
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('annualOperatingCostPerKwpEur')"
          label-for="annualOperatingCostPerKwpEur"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <UnitInputNumber
            id="annualOperatingCostPerKwpEur"
            v-model="project.investmentDeductionAllowance.annualOperatingCostPerKwpEur"
            :disabled="isBlockReadOnly"
            unit="unit_eur_per_kwp"
            :minFractionDigits="0"
            :maxFractionDigits="0"
          />
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('annualLeaseType')"
          label-for="annualLeaseType"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <b-form-input
            id="annualLeaseType"
            v-model="project.investmentDeductionAllowance.annualLeaseType"
            :disabled="isBlockReadOnly"
            type="text"
            :placeholder="$t('annualLeaseType')"
          />
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('annualLeasePercent')"
          label-for="annualLeasePercent"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <UnitInputNumber
            id="annualLeasePercent"
            v-model="project.investmentDeductionAllowance.annualLeasePercent"
            :disabled="isBlockReadOnly"
            unit="unit_percent"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <div v-if="hasSaveButton" class="text-right mt-2">
      <b-button variant="bg" :disabled="isSaving" @click="save">
        {{ $t('saveNamed', { name: $t('project_plant_data') }) }}
      </b-button>
    </div>
  </BlockFieldset>
</template>

<script>
import { mapActions } from 'vuex';
import UnitInputNumber from '@/components/UnitInputNumber';
import { formatNumberWithUnit, NUMBER_FORMAT } from '@/helpers/numberFormat';
import BlockFieldset from '@/components/Access/BlockFieldset.vue';
import { AccessBlockMixin } from '@/mixins/accessBlock';
import { BlockSaveMixin } from '@/mixins/blockSave';
import { toProjectPlantDataInput } from './projectPlantDataInput';

/** Number of the unsaved project (ProjectEdit `_new`): its values go with `createProject`. */
const NEW_PROJECT_NUMBER = '_new';

/**
 * Block project-plant-data ("Anlagedaten", plan docs/work/_done/2026-10-project-block-plant-data): the
 * plant data of `investmentDeductionAllowance` and the computed EEG tariff, saved through its own
 * mutation with its own button. On the unsaved project it has no save button. Emits `dirty` and
 * `saved`.
 */
export default {
  name: 'ProjectPlantData',
  components: {
    BlockFieldset,
    UnitInputNumber,
  },
  mixins: [AccessBlockMixin, BlockSaveMixin],
  props: {
    blockId: { type: String, required: true },
    project: { type: Object, required: true },
  },
  computed: {
    blockInput() {
      return toProjectPlantDataInput(this.project);
    },
    hasSaveButton() {
      return !this.isBlockReadOnly && this.project.number !== NEW_PROJECT_NUMBER;
    },
    calculatedEEGfeedInTariffEurPerKwhFormatted() {
      return formatNumberWithUnit(
        this.project.investmentDeductionAllowance.calculatedEEGfeedInTariffEurPerKwh,
        NUMBER_FORMAT.DECIMAL_QUINQUIPLE,
        'unit_eur_per_kwh'
      );
    },
  },
  methods: {
    ...mapActions(['updateProjectPlantData']),
    saveBlockInput(input) {
      return this.updateProjectPlantData({ projectNumber: this.project.number, input });
    },
  },
};
</script>
